var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-danger",staticStyle:{"margin-bottom":"8px"}},[_vm._m(0),_c('div',{staticClass:"normal-danger-text"},[_vm._v(" 您未授权第三方应用，功能无法正常使用，请先 "),_c('router-link',{staticClass:"text-link",attrs:{"to":`/plat/${_vm.shopId}/shop/promotion/channel`}},[_vm._v("安装第三方应用>>")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-danger-icon"},[_c('i',{staticClass:"el-icon-warning"})])
}]

export { render, staticRenderFns }